import './style/index.less';
import DeptCard from './DeptCard';

export default DeptCard;
